const elements = {
  LG: 'h1',
  MD: 'h3',
  SM: 'h5',
};

const TitleElement = (props) => {
  const { size, children, className, ...titleProps } = props;
  const Element = size ? elements[size] : elements.MD;

  return (
    <Element className={className} {...titleProps}>
      {children}
    </Element>
  );
};

export default TitleElement;
